import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useState,
  type FC,
} from "react";

import type { ComponentProps } from "~/types/components";

import { FilterContext } from "~/providers/FilterProvider";

export type FilterSectionInputProps = ComponentProps & {
  show: boolean;
  handle?: string;
  onClose: () => void;
};

export type FilterSectionOutputProps = FilterSectionInputProps & {
  selectedCount: number | "" | null;
};

export const withFilterSection =
  (Component: FC<FilterSectionOutputProps>) =>
  ({
    name = "FilterSection",
    handle,
    show,
    onClose,
    ...props
  }: FilterSectionInputProps) => {
    const { filtersSelected } = useContext(FilterContext);

    const selectedCount = React.useMemo(() => {
      const filtersByHandle = filtersSelected.find(
        (item) => item.handle === handle,
      );

      if (!filtersByHandle?.value || filtersSelected?.value === null) {
        return null;
      }

      if (filtersByHandle?.value?.length === 0) {
        return "";
      }

      if (!Array.isArray(filtersByHandle.value)) {
        return 1;
      }

      return filtersByHandle?.value?.length;
    }, [filtersSelected]);

    Component.displayName = name;
    return (
      <Component
        {...props}
        selectedCount={selectedCount}
        onClose={onClose}
        show={show}
      />
    );
  };
